import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The JavaScript Web SDK captures anonymous events by default. However, this may change depending on your `}<a parentName="p" {...{
        "href": "/docs/libraries/js/config"
      }}><inlineCode parentName="a">{`person_profiles`}</inlineCode>{` config`}</a>{` when initializing PostHog:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li"><inlineCode parentName="p">{`person_profiles: 'identified_only'`}</inlineCode>{` `}<em parentName="p">{`(recommended)`}</em>{` `}<em parentName="p">{`(default)`}</em>{` - Anonymous events are captured by default. PostHog only captures identified events for users where `}<a parentName="p" {...{
            "href": "/docs/data/persons"
          }}>{`person profiles`}</a>{` have already been created. `}</p>
      </li>
      <li parentName="ol">
        <p parentName="li"><inlineCode parentName="p">{`person_profiles: 'always'`}</inlineCode>{`  - Capture identified events for all events.`}</p>
      </li>
    </ol>
    <p>{`For example:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js-web"
      }}>{`posthog.init('<ph_project_api_key>', {
    api_host: '<ph_client_api_host>',
    defaults: '<ph_posthog_js_defaults>',
    person_profiles: 'always'
})
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      